/* Novelys NFC — ouverture du tiroir panier et de la fenetre compte.

   PRINCIPE : le script n'ajoute rien d'indispensable. L'icone panier est un
   lien vers /cart, l'icone compte un lien vers l'espace client. Ici on ne fait
   qu'intercepter le clic pour ouvrir un panneau. Script casse ou desactive, les
   deux liens fonctionnent toujours.

   TROIS CHOSES QU'UNE FENETRE MODALE DOIT FAIRE, ET QU'ON OUBLIE SOUVENT :
   1. **Retenir la tabulation.** Sans piege, on tabule derriere le voile et on
      se retrouve a activer des liens qu'on ne voit pas.
   2. **Rendre le focus** a l'element qui a ouvert le panneau a la fermeture,
      sinon on repart du haut de la page.
   3. **Bloquer le defilement du fond.** Ici c'est `.page-wrapper` qu'il faut
      figer, pas `window` : c'est lui qui defile dans ce theme. */
(function () {
  'use strict';
  if (window.__nvDrawerReady) return;
  window.__nvDrawerReady = true;

  var FOCUSABLES = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var SEUIL_ANCRAGE = 560;
  var doux = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var voile = null;
  var ouvert = null;
  var declencheur = null;

  function scroller() { return document.querySelector('.page-wrapper'); }

  function visibles(p) {
    return [].slice.call(p.querySelectorAll(FOCUSABLES)).filter(function (e) {
      return e.offsetWidth || e.offsetHeight || e.getClientRects().length;
    });
  }

  /* ---------- Verrou de defilement ----------
     Figer `.page-wrapper` fait disparaitre sa barre de defilement, donc son
     contenu s'elargit d'un coup et toute la page saute vers la droite. On rend
     la largeur perdue en marge interieure : rien ne bouge a l'ouverture. */
  function verrouiller() {
    var sc = scroller();
    if (sc) {
      var barre = sc.offsetWidth - sc.clientWidth;
      if (barre > 0) sc.style.paddingRight = barre + 'px';
    }
    document.body.classList.add('nv-locked');
  }

  function deverrouiller() {
    var sc = scroller();
    if (sc) sc.style.paddingRight = '';
    document.body.classList.remove('nv-locked');
  }

  /* ---------- Ancrage sous l'icone ----------
     Amjad, 26 aout 2026 : la fenetre compte doit tomber **sous le bonhomme**,
     pas se coller au bord droit de l'ecran. L'icone n'est pas au bord : elle
     vit dans un en-tete centre de 1380 px au maximum, donc sa position depend
     de la largeur de la fenetre. Une valeur en CSS ne peut pas suivre cela ; on
     mesure l'icone au moment de l'ouverture.

     Le bord droit de la fenetre s'aligne sur le bord droit de l'icone, puis on
     ramene le tout dans l'ecran si cela depasse. Mesurer APRES le verrou, sinon
     on vise la position d'avant la disparition de la barre de defilement.

     **Sous 560 px on n'ancre pas** : le CSS centre alors la fenetre. Une petite
     fenetre collee dans un coin de telephone est inatteignable au pouce. */
  function ancrer(p, source) {
    if (!p.classList.contains('nv-pop')) return;
    if (!source || window.innerWidth <= SEUIL_ANCRAGE) {
      p.style.left = '';
      p.style.top = '';
      p.style.right = '';
      p.style.transformOrigin = '';
      return;
    }
    var r = source.getBoundingClientRect();
    var largeur = p.offsetWidth;
    var marge = 12;
    var gauche = r.right - largeur;
    gauche = Math.max(marge, Math.min(gauche, window.innerWidth - largeur - marge));
    p.style.right = 'auto';
    p.style.left = Math.round(gauche) + 'px';
    p.style.top = Math.round(r.bottom + 10) + 'px';
    /* Elle se deploie depuis le coin de l'icone, pas depuis son propre centre. */
    p.style.transformOrigin = 'top right';
  }

  function ouvrir(nom, source) {
    var p = document.querySelector('[data-nv-panel="' + nom + '"]');
    if (!p) return false;

    /* Deuxieme clic sur la meme icone : on referme, on ne navigue pas. Et si un
       autre panneau est ouvert, on bascule. Sans cela, `ouvrir` renvoyait faux,
       le clic n'etait pas intercepte, et le lien emportait le visiteur. */
    if (ouvert === p) { fermer(); return true; }
    if (ouvert) fermer(true);

    ouvert = p;
    declencheur = source || null;

    voile.hidden = false;
    p.hidden = false;
    /* Ordre important : on retire `hidden` d'abord (un element cache n'a pas de
       dimensions), on verrouille ensuite, on mesure en dernier. */
    verrouiller();
    ancrer(p, source);
    /* On force le calcul de la mise en page avant d'ajouter la classe, sinon le
       navigateur regroupe les deux et la transition ne se joue pas. */
    void p.offsetWidth;
    voile.classList.add('is-on');
    p.classList.add('is-on');

    var f = visibles(p);
    if (f.length) f[0].focus();
    return true;
  }

  /* `bascule` : on enchaine sur un autre panneau. On ne rend alors pas le focus
     au declencheur (le nouveau panneau le prend) et on laisse le voile en place. */
  function fermer(bascule) {
    if (!ouvert) return;
    var p = ouvert;
    ouvert = null;

    p.classList.remove('is-on');
    if (!bascule) {
      voile.classList.remove('is-on');
      deverrouiller();
    }

    var cacher = function () {
      p.hidden = true;
      /* Le voile est partage : on ne le cache que si plus rien n'est ouvert.
         Sinon un panneau ferme emporterait l'assombrissement du suivant. */
      if (!ouvert) voile.hidden = true;
      /* On efface l'ancrage : si la fenetre a ete redimensionnee entre-temps,
         un `left` en dur empecherait le CSS de recentrer sur telephone. */
      p.style.left = '';
      p.style.top = '';
      p.style.right = '';
      p.style.transformOrigin = '';
    };
    if (doux || bascule) cacher(); else setTimeout(cacher, 480);

    if (!bascule && declencheur) { try { declencheur.focus(); } catch (e) {} }
    if (!bascule) declencheur = null;
  }

  function piegeTab(e) {
    if (!ouvert || e.key !== 'Tab') return;
    var f = visibles(ouvert);
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  function boot() {
    voile = document.querySelector('[data-nv-scrim]');
    if (!voile || !document.querySelector('[data-nv-panel]')) return;
    if (voile.dataset.nvReady === '1') return;
    voile.dataset.nvReady = '1';

    document.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-nv-open]');
      if (dec) {
        /* Si le panneau n'existe pas, on laisse le lien faire son travail. */
        if (ouvrir(dec.getAttribute('data-nv-open'), dec)) e.preventDefault();
        return;
      }
      if (e.target.closest('[data-nv-close]')) { e.preventDefault(); fermer(); return; }
      if (e.target === voile) fermer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ouvert) { e.preventDefault(); fermer(); return; }
      piegeTab(e);
    });

    /* La fenetre suit son icone si on redimensionne pendant qu'elle est ouverte. */
    window.addEventListener('resize', function () {
      if (ouvert) ancrer(ouvert, declencheur);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
